import { convertHeicToJpeg } from "../Utilities/heicToJpeg";

export const compressImageSmartly = async (file) => {
  // Safety net: convert HEIC if it somehow wasn't converted on select
  const normalizedFile = await convertHeicToJpeg(file);

  if (normalizedFile.size < 500000) return normalizedFile;

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(normalizedFile);
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        // Extreme Speed: 600px width par 25 images boht fast upload hongi
        const MAX_WIDTH = 600;
        const scale = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d", { alpha: false });
        ctx.imageSmoothingEnabled = false; // Disable smoothing for extra speed
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Quality 0.4: File size 80-90% reduce ho jayega
        canvas.toBlob((blob) => {
          resolve(
            new File([blob], normalizedFile.name, { type: "image/jpeg" }),
          );
        }, "image/jpeg", 0.4);
      };
      img.onerror = () => resolve(normalizedFile);
    };
    reader.onerror = () => resolve(normalizedFile);
  });
};